import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Settings01 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "settings01",
    className: clsx('stroke-current', className)
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3Z"
    }), /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18.7273 14.7273a1.5 1.5 0 0 0 .3 1.6545l.0545.0546a1.818 1.818 0 0 1 0 2.5727 1.8184 1.8184 0 0 1-2.5727 0l-.0546-.0546a1.5003 1.5003 0 0 0-1.6545-.3 1.5001 1.5001 0 0 0-.9091 1.3728v.1545a1.8182 1.8182 0 1 1-3.6364 0V20.1a1.4996 1.4996 0 0 0-.9818-1.3727 1.5002 1.5002 0 0 0-1.6545.3l-.0546.0545a1.8176 1.8176 0 0 1-1.9826.3947 1.8174 1.8174 0 0 1-.59-.3947 1.8176 1.8176 0 0 1-.5333-1.2863 1.818 1.818 0 0 1 .5332-1.2864l.0545-.0546a1.4996 1.4996 0 0 0 .3-1.6545 1.4996 1.4996 0 0 0-1.3727-.9091h-.1545a1.818 1.818 0 0 1-1.2857-3.1038 1.8182 1.8182 0 0 1 1.2857-.5326H3.9a1.4997 1.4997 0 0 0 1.3727-.9818 1.5 1.5 0 0 0-.3-1.6545l-.0545-.0546a1.8182 1.8182 0 0 1 0-2.5727 1.818 1.818 0 0 1 2.5727 0l.0545.0545a1.5 1.5 0 0 0 1.6546.3h.0727a1.5 1.5 0 0 0 .9091-1.3727v-.1545a1.8182 1.8182 0 0 1 3.6364 0V3.9a1.4997 1.4997 0 0 0 .9091 1.3727 1.4998 1.4998 0 0 0 1.6545-.3l.0546-.0545a1.8167 1.8167 0 0 1 1.2863-.5333 1.818 1.818 0 0 1 1.2864.5333 1.8189 1.8189 0 0 1 .3946 1.9826 1.8189 1.8189 0 0 1-.3946.5901l-.0546.0545a1.5007 1.5007 0 0 0-.3 1.6546v.0727a1.5004 1.5004 0 0 0 1.3728.9091h.1545a1.8183 1.8183 0 0 1 0 3.6364H20.1a1.4995 1.4995 0 0 0-1.3727.9091Z"
    })]
  }));
};
export default Settings01;